import "./styles/global.css";
import { ThemeProvider } from "@mui/material";
import { theme } from "./styles/theme";
import Content from "./layouts/Content";
import { DeviceProvider } from "./context/DeviceContext";
import { DesignProvider } from "./context/DesignContext";
import { CThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CThemeProvider>
          <DesignProvider>
            <DeviceProvider>
              <Content />
            </DeviceProvider>
          </DesignProvider>
        </CThemeProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
